import { ArrowUpRight, Star } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionTag from "@/components/SectionTag";
import { SITE, TESTIMONIALS } from "@/data/site";

export default function Reviews() {
  return (
    <section data-testid="reviews-section" className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 md:py-28 lg:px-12">
        <Reveal className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-xl">
            <SectionTag number="05" label="Patient Stories" />
            <h2 className="mt-5 font-display text-2xl font-bold tracking-tight text-brand-navy sm:text-3xl lg:text-4xl">
              Patients Feel{" "}
              <span className="font-serif italic text-brand-red">Heard Here</span>
            </h2>
          </div>
          <div data-testid="reviews-rating" className="flex items-center gap-3">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-5 w-5 fill-amber-400 text-amber-400" />
              ))}
            </div>
            <span className="text-sm font-semibold text-brand-navy">5.0 on Google</span>
          </div>
        </Reveal>
        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <figure
                data-testid={`review-card-${i + 1}`}
                className="flex h-full flex-col rounded-3xl border border-slate-100 bg-slate-50/60 p-8 transition-[background-color,box-shadow,transform] duration-300 hover:-translate-y-1 hover:bg-white hover:shadow-soft"
              >
                <span className="font-serif text-6xl leading-none text-brand-red/30">”</span>
                <blockquote className="mt-2 flex-1 text-base leading-relaxed text-slate-700">
                  {t.quote}
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-3">
                  <span className="h-px w-8 bg-brand-red" />
                  <span className="text-sm font-semibold text-brand-navy">{t.name}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2} className="mt-10">
          <a
            href={SITE.reviewsUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="google-reviews-link"
            className="group inline-flex items-center gap-2 text-sm font-semibold text-brand-red transition-colors duration-200 hover:text-brand-redhover"
          >
            Read Our Google Reviews
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
